angular.module('gym.calendar').factory('DeleteEventScheduleService', ["$modal", "CalendarLastVisitedViewService", "Calendar", "$state", "$window", function($modal, CalendarLastVisitedViewService, Calendar, $state, $window) {
  return {
    deleteRepeating: function(event, removeListeners) {
      return $modal.open({
        template: require('templates/gyms/calendar/delete_event_schedule.html.slim'),
        controller: ["$scope", "$state", "$modalInstance", "Calendar", function($scope, $state, $modalInstance, Calendar) {
          var Event;
          $scope.event = event.attributes || event;
          Event = Calendar.one('events', $scope.event.id);
          $scope.params = {
            edit_type: 'single'
          };
          $scope.isFutureEdit = function() {
            return $scope.params.edit_type === 'future';
          };
          $scope.onEditTypeChange = function() {
            if ($scope.isFutureEdit()) {
              return Event.doGET('previous_event_date').then(function(data) {
                return $scope.previousEventDate = data.previous_event_date;
              });
            }
          };
          $scope.remove = function() {
            $scope.isLoading = true;
            return Event.remove($scope.params).then(function() {
              removeListeners();
              $modalInstance.close();
              return $state.go(CalendarLastVisitedViewService.get());
            }, function() {
              return $scope.isLoading = false;
            });
          };
          return $scope.cancel = function() {
            return $modalInstance.dismiss('cancel');
          };
        }]
      });
    },
    delete: function(event, removeListeners) {
      var Event, isRepeating;
      isRepeating = !!event.repeats || !!event.repeat_until_date || !!event.infinite;
      if (isRepeating) {
        return this.deleteRepeating(event, removeListeners);
      } else {
        if ($window.confirm('Are you sure you want to delete this event?')) {
          Event = Calendar.one('events', event.id);
          return Event.remove({
            edit_type: 'single'
          }).then(function() {
            removeListeners();
            return $state.go(CalendarLastVisitedViewService.get());
          });
        }
      }
    }
  };
}]);
